import * as React from 'react';
import DOMPurify from 'dompurify';

interface OptionTypes {
	[key: string]: any;
}

interface SafeHtmlTypes {
	className?: string;
	children?: React.ReactNode;
	options?: OptionTypes;
}

const defaultOptions: OptionTypes = {
	ALLOWED_TAGS: ['p', 'b', 'i', 'em', 'strong', 'a'],
	ALLOWED_ATTR: ['href']
};

const sanitize = (dirty: string, options: {}) => {
	return {
		__html: DOMPurify.sanitize(dirty, { ...defaultOptions, ...options })
	};
};

export const SafeHtml: React.FC<SafeHtmlTypes> = ({ className = '', children, options }) => {
	const [state, setState] = React.useState({ __html: '' });

	React.useEffect(() => {
		if (children) {
			setState(sanitize(children.toString(), { ...options }));
		}
	}, [children]);

	if (children) {
		return <div className={`wysiwyg ${className}`} dangerouslySetInnerHTML={state} />;
	} else {
		return null;
	}
};

export default SafeHtml;
